import { useState, useCallback } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import LogoutConfirmation from "../../components/LogoutConfirmation";
import PortalPopup from "../../components/PortalPopup";
import DownloadModalTables from "../../components/DownloadModalTables";
import DebtorListFilter from "../../components/DebtorListFilter";
import NavigationPanel from "../../components/NavigationPanel";
import CTAs from "../../components/CTAs";
import { MoreVertical } from "lucide-react";
import Footer from "../../components/Footer";

const OutcomesAndCostsPage_4 = () => {
  const navigate = useNavigate();
  const [isLogoutConfirmationOpen, setLogoutConfirmationOpen] = useState(false);
  const [isDownloadModalTablesOpen, setDownloadModalTablesOpen] =
    useState(false);
  const [isDebtorListFilterOpen, setDebtorListFilterOpen] = useState(false);

  const onClickOutcomeUpdates = useCallback(() => {
    navigate("/outcome&cost");
  }, [navigate]);

  const onClickCostImplication = useCallback(() => {
    navigate("/outcome&cost2");
  }, [navigate]);

  const onClickJudgementPhase = useCallback(() => {
    navigate("/outcome&cost3");
  }, [navigate]);

  const onClickReportingAndAnalytics = useCallback(() => {
    navigate("/outcome&cost5");
  }, [navigate]);

  const closeLogoutConfirmation = useCallback(() => {
    setLogoutConfirmationOpen(false);
  }, []);

  const openDownloadModalTables = useCallback(() => {
    setDownloadModalTablesOpen(true);
  }, []);

  const closeDownloadModalTables = useCallback(() => {
    setDownloadModalTablesOpen(false);
  }, []);

  const openDebtorListFilter = useCallback(() => {
    setDebtorListFilterOpen(true);
  }, []);

  const closeDebtorListFilter = useCallback(() => {
    setDebtorListFilterOpen(false);
  }, []);

  const navItems = [
    {
      text: "Debt collection",
      bgColor: "bg-neutrals-neutral-50",
      textColor: "text-neutrals-neutral-300",
      hoverBgColor: "bg-neutrals-neutral-50",
      hoverTextColor: "text-primary-primary-500",
      path: "",
      icon: "assets/arrow-down.svg",
    },

    {
      text: "Outcomes & costs",
      bgColor: "bg-primary-primary-50",
      textColor: "text-neutrals-neutral-900",
      hoverBgColor: "bg-primary-primary-50",
      hoverTextColor: "text-neutrals-neutral-900",
      path: "",
      icon: "",
    },

    {
      text: "AI indicators",
      bgColor: "bg-neutrals-neutral-50",
      textColor: "text-neutrals-neutral-300",
      hoverBgColor: "bg-neutrals-neutral-50",
      hoverTextColor: "text-primary-primary-500",
      path: "/ai1",
      icon: "",
    },
  ];

  const ActionMenu = ({ debtor }) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
      <div className="relative">
        {/* three-dot icon */}
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="p-1 rounded-full hover:bg-white bg-white"
        >
          <MoreVertical className="w-5 h-5 text-neutrals-neutral-900" />
        </button>

        {/* Dropdown menu */}
        {isOpen && (
          <div className="w-full absolute right-0 mt-2 bg-white border border-gray-200 shadow-lg rounded-lg z-10">
            <button className="w-full px-4 py-2 text-sm text-left bg-transparent text-neutrals-neutral-900 rounded hover:bg-[#e5e5e5] cursor-pointer">
              Mark as read
            </button>
            <button className="w-full px-4 py-2 text-sm text-left bg-transparent text-neutrals-neutral-900 rounded hover:bg-[#e5e5e5] cursor-pointer">
              Delete
            </button>
          </div>
        )}
      </div>
    );
  };

  const [activeTab, setActiveTab] = useState("all");
  const [searchQuery, setSearchQuery] = useState("");

  const debtors_list = [
    {
      id: 1,
      name: "Paras Mistry",
      date: "23/11/23",
      subject: "Unpaid invoice #123456",
      status: "Sent",
      action: "...",
    },
    {
      id: 2,
      name: "Nathan James",
      date: "23/11/23",
      subject: "Unpaid invoice #123456",
      status: "Pending",
      action: "...",
    },
    {
      id: 3,
      name: "Diane Elgar",
      date: "23/11/23",
      subject: "Unpaid invoice #123456",
      status: "Pending",
      action: "...",
    },
    {
      id: 4,
      name: "Gareth Travell",
      date: "23/11/23",
      subject: "Unpaid invoice #123456",
      status: "Received",
      action: "...",
    },
    {
      id: 5,
      name: "Elisa Gashi",
      date: "23/11/23",
      subject: "Unpaid invoice #123456",
      status: "Sent",
      action: "...",
    },
    {
      id: 6,
      name: "Max James",
      date: "23/11/23",
      subject: "Unpaid invoice #123456",
      status: "Sent",
      action: "...",
    },
    {
      id: 7,
      name: "Binisha Mohan",
      date: "23/11/23",
      subject: "Unpaid invoice #123456",
      status: "Sent",
      action: "...",
    },
    {
      id: 8,
      name: "Mofeoluwa Ogunkanmi",
      date: "23/11/23",
      subject: "Unpaid invoice #123456",
      status: "Received",
      action: "...",
    },
    {
      id: 9,
      name: "Sara Khomami",
      date: "23/11/23",
      subject: "Unpaid invoice #123456",
      status: "Received",
      action: "...",
    },
    {
      id: 10,
      name: "Kerry James",
      date: "23/11/23",
      subject: "Unpaid invoice #123456",
      status: "Sent",
      action: "...",
    },
  ];

  const filteredDebtors =
    activeTab === "all"
      ? debtors_list
      : debtors_list.filter(
          (debtor) => debtor.status.toLowerCase() === activeTab.toLowerCase()
        );

  const searchedDebtors = filteredDebtors.filter(
    (debtor) =>
      debtor.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      debtor.date.toLowerCase().includes(searchQuery.toLowerCase()) ||
      debtor.subject.toLowerCase().includes(searchQuery.toLowerCase()) ||
      debtor.status.toLowerCase().includes(searchQuery.toLowerCase()) ||
      debtor.action.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const statusColorMap = {
    Sent: "bg-blue-100 text-blue-500 border-blue-500",
    Pending: "bg-yellow-100 text-yellow-500 border-yellow-500",
    Received: "bg-green-100 text-green-500 border-green-500",
  };

  const statusIconMap = {
    Sent: "•",
    Pending: "•",
    Received: "•",
  };

  return (
    <>
      <div className="w-full relative bg-white min-h-screen overflow-visible text-left text-base text-neutrals-neutral-300 font-open-sans-font-family-meta">
        <NavigationPanel navItems={navItems} />

        {/* Main */}
        <div className="w-full absolute top-[136px] flex flex-col items-start justify-start gap-6 px-4 md:px-4 lg:px-24 box-border">
          {/* Heading */}
          <b className="relative text-9xl text-neutrals-neutral-900">{`Outcomes & costs`}</b>

          {/* Tabs */}
          <div className="self-stretch flex flex-row items-start justify-start gap-[24px]">
            <div
              className="bg-neutrals-neutral-50 h-[41px] flex flex-row items-center justify-center pt-0 px-1 pb-3 box-border cursor-pointer"
              onClick={onClickOutcomeUpdates}
            >
              <div className="flex flex-row items-center justify-center">
                <div className="relative font-semibold">Outcome updates</div>
              </div>
            </div>
            <div
              className="bg-neutrals-neutral-50 h-[41px] flex flex-row items-center justify-center pt-0 px-1 pb-3 box-border cursor-pointer"
              onClick={onClickCostImplication}
            >
              <div className="flex flex-row items-center justify-center">
                <div className="relative font-semibold">Cost implications</div>
              </div>
            </div>
            <div
              className="bg-neutrals-neutral-50 h-[41px] flex flex-row items-center justify-center pt-0 px-1 pb-3 box-border cursor-pointer"
              onClick={onClickJudgementPhase}
            >
              <div className="flex flex-row items-center justify-center">
                <div className="relative font-semibold">Judgement phase</div>
              </div>
            </div>
            <div className="bg-neutrals-neutral-50 box-border h-[41px] flex flex-row items-center justify-center pt-0 px-1 pb-3 text-primary-primary-500 border-b-[2px] border-solid border-primary-primary-500">
              <div className="flex flex-row items-center justify-center">
                <div className="relative font-semibold">
                  Client communication
                </div>
              </div>
            </div>
            <div
              className="bg-neutrals-neutral-50 h-[41px] flex flex-row items-center justify-center pt-0 px-1 pb-3 box-border cursor-pointer"
              onClick={onClickReportingAndAnalytics}
            >
              <div className="flex flex-row items-center justify-center">
                <div className="relative font-semibold">
                  Reporting & analytics
                </div>
              </div>
            </div>
          </div>

          {/* Sub tabs */}
          <div className="self-stretch flex flex-col items-start justify-start gap-6">
            <div className="self-stretch flex flex-row items-start justify-start gap-[24px]">
              <div className="bg-neutrals-neutral-50 box-border h-[41px] flex flex-row items-center justify-center pt-0 px-1 pb-3 text-primary-primary-500 border-b-[2px] border-solid border-primary-primary-500">
                <div className="flex flex-row items-center justify-center">
                  <div className="relative font-semibold">Debtor</div>
                </div>
              </div>
              <div className="bg-neutrals-neutral-50 h-[41px] flex flex-row items-center justify-center pt-0 px-1 pb-3 box-border">
                <div className="flex flex-row items-center justify-center">
                  <div className="relative font-semibold">Solicitor</div>
                </div>
              </div>
              <div className="bg-neutrals-neutral-50 h-[41px] flex flex-row items-center justify-center pt-0 px-1 pb-3 box-border">
                <div className="flex flex-row items-center justify-center">
                  <div className="relative font-semibold">Third-party</div>
                </div>
              </div>
            </div>

            {/* Table */}
            <div className="w-full flex flex-col items-start justify-start text-sm text-neutrals-neutral-900">
              <div className="w-full rounded-t-3xs rounded-b-none box-border flex flex-row items-center justify-between py-5 px-6 text-lg border-t-[1px] border-solid border-neutrals-neutral-100 border-r-[1px] border-l-[1px]">
                <div className="flex flex-row items-center justify-start gap-[10px]">
                  <div className="relative font-semibold">Debtor list</div>
                  <div className="rounded-[5px] bg-neutrals-neutral-50 flex flex-row items-center justify-start py-0.5 px-2 gap-[6px] text-sm border-[1px] border-solid border-neutrals-neutral-100">
                    <div className="w-1.5 relative rounded-[50%] bg-primary-primary-500 h-1.5" />
                    <div className="relative font-semibold">10 entries</div>
                  </div>
                </div>
                <CTAs
                  type="  Secondarybtn"
                  text="Download"
                  borderColor="border-neutrals-neutral-100"
                  icon={
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M9 11v6l2-2M9 17l-2-2"
                        stroke="#2d404e"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                      <path
                        d="M22 10v5c0 5-2 7-7 7H9c-5 0-7-2-7-7V9c0-5 2-7 7-7h5"
                        stroke="#2d404e"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                      <path
                        d="M22 10h-4c-3 0-4-1-4-4V2l8 8Z"
                        stroke="#2d404e"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                    </svg>
                  }
                  position="relative"
                  onClick={openDownloadModalTables}
                />
              </div>
              <div className="w-full box-border flex flex-row items-center justify-between py-3 px-6 border-t-[1px] border-solid border-neutrals-neutral-100 border-r-[1px] border-l-[1px]">
                <div className="shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-neutrals-neutral-50 flex flex-row items-center justify-start border-solid border-neutrals-neutral-100 border-[1px]">
                  <button
                    onClick={() => setActiveTab("all")}
                    className={`rounded-tl-3xs rounded-tr-none rounded-br-none rounded-bl-3xs px-4 py-2 text-sm font-medium rounded-md  bg-column-bg flex flex-row items-center justify-center border-r-[1px] border-solid border-neutrals-neutral-100 ${
                      activeTab === "all"
                        ? "bg-neutrals-neutral-50"
                        : "text-neutrals-neutral-900 hover:bg-column-bg"
                    }`}
                  >
                    <div className="relative font-semibold">View all</div>
                  </button>
                  <button
                    onClick={() => setActiveTab("Sent")}
                    className={`rounded-tl-3xs rounded-tr-none rounded-br-none rounded-bl-3xs px-4 py-2 text-sm font-medium rounded-md  bg-column-bg flex flex-row items-center justify-center border-r-[1px] border-solid border-neutrals-neutral-100 ${
                      activeTab === "Sent"
                        ? "bg-neutrals-neutral-50"
                        : "text-neutrals-neutral-900 hover:bg-column-bg"
                    }`}
                  >
                    <div className="relative font-semibold">Sent</div>
                  </button>
                  <button
                    className={`flex flex-row items-center justify-center py-2 px-4 border-r-[1px] border-solid border-neutrals-neutral-100 bg-neutrals-neutral-50 ${
                      activeTab === "Pending"
                        ? "bg-neutrals-neutral-50"
                        : "text-neutrals-neutral-900 hover:bg-column-bg"
                    }`}
                    onClick={() => setActiveTab("Pending")}
                  >
                    <div className="relative font-semibold">Pending</div>
                  </button>
                  <button
                    className={`rounded-tl-none rounded-tr-3xs rounded-br-3xs rounded-bl-none flex flex-row items-center justify-center py-2 px-4 bg-neutrals-neutral-50 ${
                      activeTab === "Received"
                        ? "bg-neutrals-neutral-50"
                        : "text-neutrals-neutral-900 hover:bg-column-bg"
                    }`}
                    onClick={() => setActiveTab("Received")}
                  >
                    <div className="relative font-semibold">Received</div>
                  </button>
                </div>
                <div className="flex flex-row items-start justify-start gap-[10px] text-neutrals-neutral-300">
                  <div className="w-[294px] shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-neutrals-neutral-50 box-border flex flex-row items-center justify-start py-2.5 px-3.5 border-[1px] border-solid border-neutrals-neutral-100">
                    <div className="flex flex-row items-center justify-start gap-[10px]">
                      <img
                        className="w-5 relative h-5"
                        alt=""
                        src="assets/search.svg"
                      />
                      <div className="relative">{`Search `}</div>
                    </div>
                  </div>
                  <CTAs
                    type="Ghostbtn"
                    text="Filter"
                    textColor="text-neutrals-neutral-900"
                    bgColor="bg-neutrals-neutral-50"
                    borderColor="border-neutrals-neutral-100"
                    icon={
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M3 7h18M6 12h12M10 17h4"
                          stroke="#2d404e"
                          stroke-width="1.5"
                          stroke-linecap="round"
                        ></path>
                      </svg>
                    }
                    position="relative"
                    onClick={openDebtorListFilter}
                  />
                </div>
              </div>
              <div className="w-full flex flex-col items-start justify-start">
                <div className="w-full flex flex-row items-start justify-start">
                  <table className="min-w-full divide-y divide-gray-200 border-collapse">
                    <thead className="bg-column-bg">
                      <tr>
                        <th
                          scope="col"
                          className="items-start justify-start py-3 px-4 border-t-[1px] border-b-[1px] border-l-[1px] border-solid border-neutrals-neutral-100 font-open-sans-ff-meta-strong"
                        >
                          Debtor name
                        </th>
                        <th
                          scope="col"
                          className="items-start justify-start py-3 px-4 border-t-[1px] border-b-[1px] border-solid border-neutrals-neutral-100 font-open-sans-ff-meta-strong"
                        >
                          Date
                        </th>
                        <th
                          scope="col"
                          className="items-start justify-start py-3 px-4 border-t-[1px] border-b-[1px] border-solid border-neutrals-neutral-100 font-open-sans-ff-meta-strong"
                        >
                          Subject
                        </th>
                        <th
                          scope="col"
                          className="items-start justify-start py-3 px-4 border-t-[1px] border-b-[1px] border-solid border-neutrals-neutral-100 font-open-sans-ff-meta-strong"
                        >
                          Status
                        </th>
                        <th
                          scope="col"
                          className="items-start justify-start py-3 px-4 border-t-[1px] border-b-[1px] border-r-[1px] border-solid border-neutrals-neutral-100 font-open-sans-ff-meta-strong"
                        >
                          Action
                        </th>
                      </tr>
                    </thead>
                    <tbody className="bg-neutrals-neutral-50 divide-y divide-gray-200">
                      {searchedDebtors.map((debtors_list) => (
                        <tr key={debtors_list.id} className="hover:bg-gray">
                          <td className="p-4 items-start border-solid border-b-[1px] border-l-[1px] border-neutrals-neutral-100">
                            {debtors_list.name}
                          </td>
                          <td className="p-4 items-start border-solid border-b-[1px] border-neutrals-neutral-100">
                            {debtors_list.date}
                          </td>
                          <td className="p-4 items-start border-solid border-b-[1px] border-neutrals-neutral-100">
                            {debtors_list.subject}
                          </td>
                          <td className="p-4 items-start border-solid border-b-[1px] border-neutrals-neutral-100 whitespace-nowrap">
                            <span
                              className={`px-2 py-0.5 text-xs font-semibold rounded-full border-solid border-[1px] border-current ${
                                statusColorMap[debtors_list.status]
                              }`}
                            >
                              <span className="mr-1">
                                {statusIconMap[debtors_list.status]}
                              </span>
                              {debtors_list.status}
                            </span>
                          </td>
                          <td className="p-4 items-start border-solid border-b-[1px] border-r-[1px] border-neutrals-neutral-100">
                            <ActionMenu />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                {/* Pagination */}
                <div className="w-full rounded-t-none rounded-b-3xs box-border flex flex-row items-center justify-between pt-3 px-6 pb-4 border-r-[1px] border-solid border-neutrals-neutral-100 border-b-[1px] border-l-[1px]">
                  <div className="shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-neutrals-neutral-50 flex flex-row items-center justify-center py-2.5 px-3.5 border-[1px] border-solid border-neutrals-neutral-100">
                    <div className="flex flex-row items-center justify-center">
                      <div className="relative font-semibold">Previous</div>
                    </div>
                  </div>
                  <div className="relative">Page 1 of 10</div>
                  <div className="shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-neutrals-neutral-50 flex flex-row items-center justify-center py-2.5 px-3.5 border-[1px] border-solid border-neutrals-neutral-100">
                    <div className="flex flex-row items-center justify-center">
                      <div className="relative font-semibold">Next</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Footer />
          </div>
        </div>
      </div>

      {isLogoutConfirmationOpen && (
        <PortalPopup
          overlayColor="rgba(113, 113, 113, 0.3)"
          placement="Centered"
          onOutsideClick={closeLogoutConfirmation}
        >
          <LogoutConfirmation onClose={closeLogoutConfirmation} />
        </PortalPopup>
      )}
      {isDownloadModalTablesOpen && (
        <PortalPopup
          overlayColor="rgba(113, 113, 113, 0.3)"
          placement="Centered"
          onOutsideClick={closeDownloadModalTables}
        >
          <DownloadModalTables onClose={closeDownloadModalTables} />
        </PortalPopup>
      )}
      {isDebtorListFilterOpen && (
        <PortalPopup
          overlayColor="rgba(113, 113, 113, 0.3)"
          placement="Centered"
          onOutsideClick={closeDebtorListFilter}
        >
          <DebtorListFilter onClose={closeDebtorListFilter} />
        </PortalPopup>
      )}
    </>
  );
};

export default OutcomesAndCostsPage_4;
